import { Circle } from '@phosphor-icons/react';
import { ICellRendererParams } from 'ag-grid-community';
import { useTranslation } from 'react-i18next';

import { DEFAULT_PLACEHOLDER } from 'core/constants';
import { TextLine, Tooltip } from 'core/elements';
import { getAgGridTableCellData } from 'core/utils';
import { filenetStatusColorMap } from 'quotes/constants';
import { FilenetStatus, FilenetStatusLabel, QuoteStatus } from 'quotes/enums';
import { Color, TooltipPosition } from 'theme/enums';

const dotDecorator = <Circle weight="fill" style={{ fontSize: 10 }} />;

export const FilenetStatusCell = (props: ICellRendererParams) => {
  const { t } = useTranslation();
  const data = getAgGridTableCellData(props, 'filenetStatus');
  if (!data) {
    return props?.value;
  }

  const { filenetStatus, filenetError, status } = data;
  if (!filenetStatus) {
    if (QuoteStatus.EDITABLE_BY_CUSTOMER === status) {
      return (
        <TextLine
          text={t('labelNotSentToFileNet')}
          color={Color.NEUTRAL}
          decorator={dotDecorator}
        />
      );
    }

    return <TextLine text={DEFAULT_PLACEHOLDER} />;
  }

  const textLine = (
    <TextLine
      text={FilenetStatusLabel[filenetStatus]}
      color={filenetStatusColorMap[filenetStatus]}
      decorator={dotDecorator}
    />
  );

  if (FilenetStatus.FAILED === filenetStatus && filenetError) {
    return (
      <Tooltip color={Color.DANGER} placement={TooltipPosition.TOP} title={filenetError}>
        {textLine}
      </Tooltip>
    );
  }

  return textLine;
};
